import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/features/auth/AuthContext";
import { ImpersonationProvider } from "@/features/sales/ImpersonationContext";
import { CartProvider } from "@/features/cart/CartContext";
import { PriceVisibilityProvider } from "@/features/catalog/PriceVisibilityContext";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/app/ErrorBoundary";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ImpersonationProvider>
            <CartProvider>
              <PriceVisibilityProvider>
                <TooltipProvider>
                  <BrowserRouter>{children}</BrowserRouter>
                  <Toaster position="top-center" richColors />
                </TooltipProvider>
              </PriceVisibilityProvider>
            </CartProvider>
          </ImpersonationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
